module.exports = {
      id: "success-usage",
      viewBox: "0 0 136 136",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#success",
      toString: function () {
        return this.url;
      }
    }